<script setup>
const route=useRoute();
</script>
<template><RatingDirectory :key="route.path" :category-slug="String(route.params.subcategory)"/></template>
